module.exports = __webpack_public_path__ + "media/illustrations/piggy-bank-51d249db.svg";